import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect, useHistory } from 'react-router-dom';
import { useAuth } from '~/context/AuthContext';

export default function RouteWrapper({
  component: Component,
  isPrivate,
  ...rest
}) {
  const { user } = useAuth();
  const history = useHistory();

  function isUserOnlyDelivery(user) {
    if (user?.only_delivery) {
      return '/delivery/orders';
    }
    return '/operation';
  }

  const alwaysAccessiblePaths = ['/login-by-token'];

  return (
    <Route
      {...rest}
      render={(props) => {
        const { pathname, search, state } = props.location;

        // libera rotas públicas
        if (alwaysAccessiblePaths.some((path) => pathname.startsWith(path))) {
          return <Component {...props} />;
        }

        // valida autenticação
        if (isPrivate && !user) {
          return <Redirect to="/" />;
        }

        if (!isPrivate && user) {
          return <Redirect to={isUserOnlyDelivery(user)} />;
        }

        if (user?.name) {
          const params = new URLSearchParams(search);

          if (!params.get('name')) {
            params.set('name', user.name);
            const newSearch = `?${params.toString()}`;

            if (newSearch !== search) {
              history.replace({
                pathname,
                search: newSearch,
                state,
              });
            }
          }
        }

        return <Component {...props} />;
      }}
    />
  );
}

RouteWrapper.propTypes = {
  isPrivate: PropTypes.bool,
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func]).isRequired,
};

RouteWrapper.defaultProps = {
  isPrivate: false,
};
